import styles from './index.module.scss'
import { Button, Upload, message, Select } from "antd"
import { useCallback, useMemo, useContext, useState, useRef, useEffect } from "react"
import Utils from '@utils/utils';
import { IMAGE_TYPE, GENERATE_MODE } from '@utils/CONST';
import { AppContext } from '@utils/AppContext';
import PSAIModal from '@PSAIComponents/PSAIModal';
import Iconfont from '@utils/Iconfont';
import API from "@api/api";
import { GenerateContext } from '../../../hooks/GenerateContext'
import { workflowOfGenerate } from '@utils/workflowOfBuildTaskV2'
import PromptIcon from '@assets/images/svgIcon/promptIcon.svg'



const UploadInput = (props) => {
    const { setSelectedTaskListId } = useContext(AppContext);
    const { modelImage } = props
    const generateContext = useContext(GenerateContext)
    const { setProjectId, generateNum, setGenerateNum, prompt, setPrompt, matchImages, setMatchImages, generateMode, setGenerateMode } = generateContext
    const [uploading, setUploading] = useState(false)
    const [uploadFileList, setUploadFileList] = useState([])
    const [errorOpen, setErrorOpen] = useState(false)
    const [errorList, setErrorList] = useState([])
    const [promptLoading, setPromptLoading] = useState(false)
    const [generateLoading, setGenerateLoading] = useState(false)
    const [showPlaceholder, setShowPlaceholder] = useState(!prompt)
    const [currentBatchUploadedCount, setCurrentBatchUploadedCount] = useState(0)
    const isMounted = useRef(true)
    const lastPromptRequestId = useRef(0)

    useEffect(() => {
        isMounted.current = true
        return () => {
            isMounted.current = false
        }
    }, [])

    // 停止上传
    const uploadAbort = useRef(false)
    const handleUploadAbort = () => {
        uploadAbort.current = true
    }
    // 正在上传的图片
    const remainUploadLength = useMemo(() => {
        return matchImages.length + errorList.length
    }, [uploadFileList, matchImages, errorList])

    const lastUploadBatchKeyRef = useRef("")
    const dropBatchKeyRef = useRef("")

    const getUploadBatchKey = (files) => {
        return (Array.from(files || [])).map((f) => `${f?.uid || ""}-${f?.name || ""}-${f?.size || ""}-${f?.lastModified || ""}`).join("|")
    }

    const beforeUpload = async (file, fileList) => {
        const files = Array.from(fileList || [])
        if (!files.length) return false

        const batchKey = getUploadBatchKey(files)

        if (dropBatchKeyRef.current === batchKey) return false

        const last = files[files.length - 1]
        if (last?.uid ? file?.uid !== last.uid : file !== last) return false

        if (lastUploadBatchKeyRef.current === batchKey) return false
        lastUploadBatchKeyRef.current = batchKey

        console.log('===beforeUpload===')
        handleUpload(files)
        return false
    }

    const handleDrop = async (e) => {
        e.stopPropagation()
        e.preventDefault()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const files = await Utils.getFilesFromDirs(filesAndDirs, "/")
            const batchKey = getUploadBatchKey(files)
            dropBatchKeyRef.current = batchKey
            lastUploadBatchKeyRef.current = batchKey

            handleUpload(Array.from(files || []))
            return false
        }
    }

    const handleUpload = async (fileList) => {
        console.log('fileList', fileList)
        if (fileList.length >= 10) message.warning('最多只能上传10张图片，多余的图片将被丢弃！')
        const errorList = []
        const nextSuccessList = [...matchImages]
        setErrorList([...errorList])
        setMatchImages([...nextSuccessList])

        try {
            setUploading(true)
            setCurrentBatchUploadedCount(0)

            fileList = [...fileList].slice(0, 10 - nextSuccessList.length)
            setUploadFileList(fileList)

            for (let file of fileList) {
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                try {
                    await Utils.validateImageFile(file, true)
                } catch (err) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                let resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)

                if (!resizeRes || !resizeRes.success) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                } else file = resizeRes.file
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                // 上传图片
                const res = await Utils.checkImageIslegal(file, 0, IMAGE_TYPE.FUSION_WEAR)
                if (!res || !res.isLegal) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                const url = res.data
                nextSuccessList.push({ url })
                setMatchImages([...nextSuccessList])
                setCurrentBatchUploadedCount(prev => prev + 1)
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setErrorList([...errorList])
            setMatchImages([...nextSuccessList])
            setUploading(false)
            // if (errorList.length > 0) setErrorOpen(true)
            if (errorList.length > 0) message.error(`含有${errorList.length}张不符合要求的图片，已丢弃。`, 5)
        }
    }

    const handleDelete = (index) => {
        const nextSuccessList = [...matchImages]
        nextSuccessList.splice(index, 1)
        setMatchImages([...nextSuccessList])
    }


    // 输入框-------------------------
    const contentEditableRef = useRef(null)
    const KEYWORDS = useMemo(() => {
        const kws = ['模特', ...Array.from({ length: 10 }, (_, i) => `图${i + 1}`)];
        return kws.sort((a, b) => b.length - a.length);
    }, [])

    const getInputValue = useCallback(() => {
        if (!contentEditableRef.current) return "";
        let text = contentEditableRef.current.innerText;
        // 移除可能存在的括号，防止重复
        let cleanText = text.replace(/【|】/g, '');
        const pattern = new RegExp(`(${KEYWORDS.join('|')})`, 'g');
        // 给关键词加上括号
        return cleanText.replace(pattern, '【$1】');
    }, [KEYWORDS])


    const saveSelection = (containerEl) => {
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return null;
        const range = selection.getRangeAt(0);
        const preSelectionRange = range.cloneRange();
        preSelectionRange.selectNodeContents(containerEl);
        preSelectionRange.setEnd(range.startContainer, range.startOffset);
        const start = preSelectionRange.toString().length;
        return {
            start: start,
            end: start + range.toString().length
        };
    };

    const restoreSelection = (containerEl, savedSelection) => {
        if (!savedSelection) return;
        let charIndex = 0, range = document.createRange();
        range.setStart(containerEl, 0);
        range.collapse(true);
        let nodeStack = [containerEl], node, foundStart = false, stop = false;

        while (!stop && (node = nodeStack.pop())) {
            if (node.nodeType === 3) {
                const nextCharIndex = charIndex + node.length;
                if (!foundStart && savedSelection.start >= charIndex && savedSelection.start <= nextCharIndex) {
                    range.setStart(node, savedSelection.start - charIndex);
                    foundStart = true;
                }
                if (foundStart && savedSelection.end >= charIndex && savedSelection.end <= nextCharIndex) {
                    range.setEnd(node, savedSelection.end - charIndex);
                    stop = true;
                }
                charIndex = nextCharIndex;
            } else {
                let i = node.childNodes.length;
                while (i--) {
                    nodeStack.push(node.childNodes[i]);
                }
            }
        }
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    };

    const formatText = useCallback((text) => {
        let cleanText = text.replace(/【|】/g, '');
        const pattern = new RegExp(`(${KEYWORDS.join('|')})`, 'g');
        return cleanText.replace(pattern, '<span class="keyword-highlight">$1</span>');
    }, [KEYWORDS])

    const isComposing = useRef(false)

    const handleContentInput = useCallback((e) => {
        let text = e.target.innerText;
        const isEmpty = text.replace(/\n/g, '').length === 0;
        setShowPlaceholder(isEmpty);

        if (isComposing.current) return;

        // 限制800字
        if (text.length > 800) {
            text = text.slice(0, 800);
            message.warning("最多输入800字");
        }

        // 处理清空的情况，防止留有 <br> 或 \n 导致 placeholder 不显示
        if (isEmpty) {
            if (e.target.innerHTML !== "") {
                e.target.innerHTML = "";
                // 恢复光标到起始位置
                const range = document.createRange();
                range.setStart(e.target, 0);
                range.collapse(true);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
            return;
        }

        const selection = saveSelection(e.target);
        const newHTML = formatText(text);

        if (e.target.innerHTML !== newHTML) {
            e.target.innerHTML = newHTML;
            restoreSelection(e.target, selection);
        }
    }, [formatText])

    const handleCompositionStart = () => {
        isComposing.current = true;
    }

    const handleCompositionEnd = (e) => {
        isComposing.current = false;
        handleContentInput(e);
    }

    const editableDiv = useMemo(() => (
        <div
            ref={contentEditableRef}
            className={styles.contenteditableWrap}
            contentEditable
            onInput={handleContentInput}
            onCompositionStart={handleCompositionStart}
            onCompositionEnd={handleCompositionEnd}
            suppressContentEditableWarning
        />
    ), [handleContentInput])

    useEffect(() => {
        if (contentEditableRef.current) {
            const initialText = prompt || "";
            contentEditableRef.current.innerHTML = formatText(initialText);
            setShowPlaceholder(initialText.length === 0)
        }
    }, [formatText, prompt])

    // 获取搭配上身提示词
    const getAlgoPrompt = () => {
        const requestId = ++lastPromptRequestId.current
        setPromptLoading(true)
        setShowPlaceholder(false)
        API.getAlgoPrompt({
            images: matchImages.map(item => item.url),
            modelImage: modelImage
        }).then(res => {
            if (requestId !== lastPromptRequestId.current) return
            if (res?.code == 0) {
                setPrompt(res.data?.[0] || '')
                if (contentEditableRef.current) contentEditableRef.current.innerHTML = formatText(res.data?.[0] || '')
            } else {
                throw new Error(res.message)
            }
        }).catch(err => {
            if (requestId !== lastPromptRequestId.current) return
            message.error(err.message)
        })
            .finally(() => {
                if (requestId === lastPromptRequestId.current) {
                    setPromptLoading(false)
                }
            })
    }

    // 清空选项
    useEffect(() => {
        if (matchImages.length == 0 && !modelImage) {
            setPrompt('')
            setProjectId('')
            if (contentEditableRef.current) contentEditableRef.current.innerHTML = ''
            lastPromptRequestId.current = 0
        }
        if (matchImages.length > 0 || modelImage) {
            // getAlgoPrompt()
        }
    }, [matchImages, modelImage])

    // 生成搭配上身
    const handleGenerate = async () => {
        const prompt = await getInputValue()
        setPrompt(prompt)

        try {
            // 需要登录
            const status = Utils.checkLoginStatus(() => handleGenerate())
            if (!status) return

            setGenerateLoading(true)
            const currentGenerateContext = {
                ...generateContext,
                prompt: prompt
            }
            const projectId = await workflowOfGenerate(IMAGE_TYPE.FUSION_WEAR, currentGenerateContext, {
                projectId: generateContext.projectId
            })
            if (!projectId) return
            setSelectedTaskListId(projectId)
            setProjectId(projectId)
            message.success("生成中，请稍等片刻")
            props.createClick()
        } catch (err) {
            console.log(err)
            message.warning(err.message)
        } finally {
            setGenerateLoading(false)
        }
    }

    const uploadAfterWrap = (
        <div className={styles.successUploadWrap}>
            <div className={styles.imgList}>
                {
                    matchImages.map((item, index) => (
                        <div className={styles.imgItem} key={item.url}>
                            <img src={Utils.getImgThumbnail(item.url)} alt="" />
                            <span className={styles.imgName}>图{index + 1}</span>
                            <div className={styles.deleteIcon} onClick={() => handleDelete(index)}>
                                <Iconfont className={styles.Icon} type="icon-DeleteOutlined" />
                            </div>
                        </div>
                    ))
                }
                {
                    modelImage &&
                    <div className={styles.imgItem}>
                        <img src={Utils.getImgThumbnail(modelImage)} alt="" />
                        <span className={styles.imgName}>模特</span>
                        <div className={styles.deleteIcon} onClick={() => props.setModelImage([])}>
                            <Iconfont className={styles.Icon} type="icon-DeleteOutlined" />
                        </div>
                    </div>
                }
                {
                    matchImages.length < 10 &&
                    <div className={styles.uploadItem}>
                        <Upload
                            accept='image/jpeg,image/png,image/webp,image/avif'
                            listType="picture-card"
                            showUploadList={false}
                            multiple
                            beforeUpload={beforeUpload}
                        >
                            <Iconfont className={styles.Icon} type="icon-general_dd" />
                        </Upload>
                    </div>
                }
            </div>
        </div>
    )

    return (
        <div className={styles.UploadInput}>
            {
                matchImages.length > 0 || modelImage ? <>
                    {uploadAfterWrap}
                    <div className={styles.inputContainer}>
                        {showPlaceholder && (
                            <div className={styles.placeholderOverlay}>
                                请描述想要生成的画面，或点击
                                <span onClick={getAlgoPrompt} className={styles.smartPromptLink}>智能提示词</span>
                                自动生成
                            </div>
                        )}
                        {editableDiv}
                    </div>
                    <div className={styles.uploadParams}>
                        <Button
                            onClick={props.handleOpenDrawer}
                            className={styles.smartPromptBtn2}
                        >
                            选择模特
                        </Button>
                        {/* {
                            uploading && <span className={styles.uploadNum}><LoadingOutlined style={{ marginRight: 8 }} /> 已上传{currentBatchUploadedCount} / 共{uploadFileList.length}张</span>
                        } */}
                        <div className={styles.rightGroupsBtn}>
                            <Button
                                loading={promptLoading}
                                className={styles.smartPromptBtn}
                                onClick={getAlgoPrompt}
                            >
                                {!promptLoading && <img style={{ width: 16 }} src={PromptIcon} alt="" />}
                                智能提示词</Button>
                            <Select
                                defaultValue={generateMode}
                                style={{ width: 115, height: 32 }}
                                onChange={(value) => setGenerateMode(value)}
                                options={[{
                                    value: GENERATE_MODE.STD,
                                    label: '标准模式',
                                }, {
                                    value: GENERATE_MODE.HQ,
                                    label: '高品质模式',
                                }]}
                            />
                            <Select
                                defaultValue={generateNum}
                                style={{ width: 100, height: 32 }}
                                onChange={(value) => setGenerateNum(value)}
                                options={[1, 2, 3, 4].map(n => ({
                                    value: n,
                                    label: `${n}张`,
                                }))}
                            />
                            <Button
                                onClick={() => handleGenerate()}
                                disabled={matchImages.length == 0}
                                className={styles.generateBtn}
                                type="primary"
                                loading={generateLoading}>
                                生成 <img style={{ width: 16 }} src={require('@assets/images/arcbean3.png')} />
                                {(generateMode === GENERATE_MODE.STD ? 10 : 15) * generateNum}
                            </Button>
                        </div>
                    </div>
                </> :
                    <Upload.Dragger
                        className={styles.Uploader}
                        accept='image/jpeg,image/png,image/webp,image/avif'
                        listType="picture-card"
                        showUploadList={false}
                        multiple
                        beforeUpload={beforeUpload}
                        onDrop={handleDrop}
                    >
                        <div className={styles.UploadInputContent}>
                            <img src={"https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/uploadModelIcon.png"} alt="" />
                            <p>点击 或 拖拽到此处上传1-10张穿搭商品图</p>
                        </div>
                    </Upload.Dragger>
            }

            {/* {
                uploading && <div className={styles.uploadNumber}>
                    <p><span>{remainUploadLength} / {uploadFileList.length} 正在上传</span> <span onClick={handleUploadAbort}>停止</span></p>
                    <Progress percent={Math.ceil(remainUploadLength / uploadFileList.length * 100)} showInfo={false} />
                </div>
            } */}
            <PSAIModal
                open={errorOpen}
                title="上传失败图片"
                okText={"确定"}
                cancelText={"取消"}
                maxWidth={540}
                onOk={() => {
                    setErrorList([])
                    setErrorOpen(false)
                }}
                onCancel={() => {
                    setErrorOpen(false)
                }}
                onClose={() => setErrorOpen(false)}
            >
                {
                    <div className={styles.ErrorUploadNotice2}>
                        <p>请检查以下大于30M，分辨率小于500*500px，长宽比超过2:1，非JPG/PNG/WEBP图片</p>
                        <ul className="_beauty_scrollbar">
                            {
                                errorList.map((item, index) => (
                                    <li key={index}>{item.name}</li>
                                ))
                            }
                        </ul>
                    </div>
                }
            </PSAIModal>
        </div>
    )
}

export default UploadInput